import { useContext } from 'react'
import DeckContext from '../context'

export const useDeck = () => useContext(DeckContext)
export default useDeck
